import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function COUNT
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={30}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default COUNT